import { merge } from 'lodash';

/* eslint-disable no-unused-vars */

// set up the default state for the module
const initialState = {
  client: {
    name: 'All Clients',
    code: '',
    selected: 0,
    listVisible: false,
    hasReplacements: false,
  },
  clientList: [],
  product: {
    code: 'Universe',
    name: 'All products',
    selected: 0,
    listVisible: false,
  },
  series: {
    selectedFundToBeAdded: null,
  },
  searchTerm: '',
  currentRows: 0,
  totalRows: 0,
  tab: 'universe',
};

const actions = {
  setClient: {
    root: true,
    handler({ commit, state }, payload) {
      commit('updateClient', payload);
    },
  },
  setClientName: {
    root: true,
    handler({ commit, state }, name) {
      commit('updateClientName', name);
    },
  },
  setClientList: {
    root: true,
    handler({ commit, state }, payload) {
      commit('updateClientList', payload);
    },
  },
  setClientSelected: {
    root: true,
    handler({ commit, state }, selected) {
      commit('updateClientSelected', selected);
    },
  },
  setClientListVisible: {
    root: true,
    handler({ commit, state }, visible) {
      commit('updateClientListVisible', visible);
    },
  },
  setProduct: {
    root: true,
    handler({ commit, state }, payload) {
      commit('updateProduct', payload);
    },
  },
  setProductName: {
    root: true,
    handler({ commit, state }, name) {
      commit('updateProductName', name);
    },
  },
  setProductCode: {
    root: true,
    handler({ commit, state }, code) {
      commit('updateProductCode', code);
    },
  },
  setProductSelected: {
    root: true,
    handler({ commit, state }, selected) {
      commit('updateProductSelected', selected);
    },
  },
  setProductListVisible: {
    root: true,
    handler({ commit, state }, visible) {
      commit('updateProductListVisible', visible);
    },
  },
  setSearchTerm: {
    root: true,
    handler({ commit, state }, term) {
      commit('updateSearchTerm', term);
    },
  },
  setCurrentRows: {
    root: true,
    handler({ commit, state }, number) {
      commit('updateCurrentRows', number);
    },
  },
  setTotalRows: {
    root: true,
    handler({ commit, state }, number) {
      commit('updateTotalRows', number);
    },
  },
  setTab: {
    root: true,
    handler({ commit, state }, selected) {
      commit('updateTab', selected);
    },
  },
  setSelectedFundToBeAdded: {
    root: true,
    handler({ commit, state }, selected) {
      commit('setSelectedFundToBeAdded', selected);
    },
  },
};

const mutations = {
  updateClient(state, payload) {
    state.client = merge(state.client, payload);
  },
  updateClientName(state, name) {
    state.client.name = name;
  },
  updateClientList(state, payload) {
    state.clientList = payload;
  },
  updateClientSelected(state, selected) {
    state.client.selected = selected;
  },
  updateClientListVisible(state, visible) {
    state.client.listVisible = visible;
  },
  updateProduct(state, payload) {
    state.product = merge(state.product, payload);
  },
  updateProductName(state, name) {
    state.product.name = name;
  },
  updateProductCode(state, code) {
    state.product.code = code;
  },
  updateProductSelected(state, selected) {
    state.product.selected = selected;
  },
  updateProductListVisible(state, visible) {
    state.product.listVisible = visible;
  },
  updateSearchTerm(state, term) {
    state.searchTerm = term;
  },
  updateCurrentRows(state, number) {
    state.currentRows = number;
  },
  updateTotalRows(state, number) {
    state.totalRows = number;
  },
  updateTab(state, selected) {
    state.tab = selected;
  },
  setSelectedFundToBeAdded(state, selected) {
    state.series.selectedFundToBeAdded = selected;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
